import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { LOGOUT } from "data-handler/ducks/auth";
/**
 * Logs out, redirects to root, renders `null`
 */
export default () => {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch({ type: LOGOUT });
  }, [dispatch]);

  return null;
};
